import { animate, animateChild, query, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { PhotoCarouselService } from '../../services/photo-carousel.service';
import { AppSettings } from '../../pages/maintenance/model/appSettings';
import { Helper } from '../../pages/common/helper';
import { ToastrService } from 'ngx-toastr';
import { OnlineOfflineService } from '../../services/online-offline.service';
import { filter } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('fadeOut', [
      transition(':leave', [
        query(':leave', animateChild(), { optional: true }),
        animate(1300, style({ opacity: 0 }))
      ]),
    ]),
  ],
  styles: [`
        .splash-screen {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 9999;
        }
    `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SplashScreenComponent implements OnInit {
  show = true;
  photoCarouselImageDirectoryPath!: string;
  private errorMessageList: string[] = [];

  currentRoute: string = '';

  constructor(private router: Router,
    private cdr: ChangeDetectorRef,
    private swUpdate: SwUpdate,
    private photoCarouselService: PhotoCarouselService,
    private readonly onlineOfflineService: OnlineOfflineService,
  ) {
  }
  ngOnInit() {

    if (!this.onlineOfflineService.isOnline) {
      this.router.navigate(['admin/home']);
    }
    else {

      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event: any) => {
          this.currentRoute = event.urlAfterRedirects; // Get the route after redirects
        });

      this.getPhotoCarouselImageDirectoryPath().then(() => {
        this.getBackgroungImage();
      });

      this.updateClient();

    }

  }

  async updateClient() {

    if (!this.swUpdate.isEnabled) {
      console.log('Service Worker not enabled, go to login page');
      this.router.navigate(['/login']);
      return;
    }

    try {

      console.log('Checking for updates...');

      const hasUpdate = await this.swUpdate.checkForUpdate();

      if (hasUpdate) {

        console.log('Update found. Activating...');

        await this.swUpdate.activateUpdate();

        console.log('New version activated. Reloading...');

        location.reload();
        return;
      }

      console.log('No update found. Redirecting to login...');

      this.router.navigate(['/login']);

    } catch (err) {

      console.error('Error checking for updates:', err);

      this.router.navigate(['/login']);
    }
  }

  getPhotoCarouselImageDirectoryPath(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.photoCarouselService.getPhotoCarouselImageDirectoryPath().subscribe(
        (res: any) => {
          if (this.isResponseValid(res)) {
            let appSettings: AppSettings[] = res.entity.list;
            this.photoCarouselImageDirectoryPath = appSettings[0].settingValue;
            resolve(true);
          }
        });
    });
    return promise;
  }

  getBackgroungImage() {

    this.photoCarouselService.getPhotoCarouselList('1', '2').subscribe(
      (res: any) => {
        if (this.isResponseValid(res)) {
          let bckGrndImage = res.entity.list;
          if (bckGrndImage.length > 0) {
            let indx = Math.floor(Math.random() * bckGrndImage.length);
            if (bckGrndImage[indx].photoLinkUrl != '') {
              let imageFilePath = Helper.GetUserFilesRelativePath(this.photoCarouselImageDirectoryPath + bckGrndImage[indx].applicationTypeCode + '\\' + bckGrndImage[indx].photoLinkUrl);
              document.getElementById('loginBackGround')!.style.backgroundImage = 'none';
              document.getElementById('loginBackGround')!.style.backgroundImage = 'url(' + imageFilePath + ')';
            }
            else {
              var images = ['ifs_background1.jpg',
                'ifs_background2.jpg',
                'ifs_background3.jpg',
                'ifs_background4.jpg',
                'ifs_background5.jpg',
                'ifs_background6.jpg',
                'ifs_background7.jpg',
                'ifs_background8.jpg',
                'ifs_background9.jpg',
                'ifs_background10.jpg'];

              document.getElementById('loginBackGround')!.style.backgroundImage = 'none';
              document.getElementById('loginBackGround')!.style.backgroundImage = 'url(' + './assets/images/background/' + images[Math.floor(Math.random() * images.length)] + ')';
            }
          }
        }
      }
    )

  }

  isResponseValid(res: any): boolean {
    // reset validation
    this.errorMessageList = [];

    if (res.errorMessage.length > 0) {
      this.errorMessageList.push(res.errorMessage[0].message);
    }

    return (this.errorMessageList.length === 0);
  }
}
